<section class="section-wrapper">
    <h2 class="cam-heading">{{content?.['b2b.managepolicy.title']}}</h2>
    <hr class="border-0 border-top-gray mb-4">
    <div class="section-context border-0 p-0"
        [class.f-direction-column]="commonObj.STATE == 'LIST' || commonObj.STATE == 'WAITING'">
        <ng-container [ngSwitch]="commonObj.STATE">
            <ng-container *ngSwitchCase="'LIST'">
                <div class="f-row filter-row mb-8 mb-md-0 custom-filter-container"
                    [formGroup]="policyManagementListsModel">
                    <div class="component-search">
                        <span class="f-row">
                            <mat-icon fontSet="material-symbols-outlined" class="search-icon"> search </mat-icon>
                        </span>
                        <input [placeholder]="content?.['b2b.managepolicy.search']" name="search"
                            [style.lineHeight.px]="20" formControlName="searchValue" autocomplete="off">
                        <mat-icon fontSet="material-symbols-outlined" class="search-icon cursor-pointer"
                            *ngIf="!!policyManagementListsModel.value.searchValue" (click)="closeSearch()" tabindex="0"
                            aria-label="close search" (keydown.enter)="closeSearch()" (keyup.space)="closeSearch()">
                            close </mat-icon>
                    </div>
                    <div class="sorting">
                        <div class="filter-block">
                            <label class="label-filter cursor-pointer" for="filter" (click)="openFilter(filterModal)"
                                id="filterModal" tabindex="0" role="button" (keydown.enter)="openFilter(filterModal)"
                                (keyup.space)="openFilter(filterModal)"> {{content?.['b2b.managepolicy.filter']}}
                                <mat-icon fontSet="material-symbols-outlined">{{commonObj.isFilterOpened ?
                                    'keyboard_arrow_up':'keyboard_arrow_down'}}</mat-icon></label>
                        </div>
                        <mat-form-field class="selection-filter">
                            <label class="mat-label" (click)="sortBy()" aria-label="sort flight filter" tabindex="0"
                                role="button" (keydown.enter)="sortBy()"
                                (keyup.space)="sortBy()">{{content?.['b2b.managepolicy.sortby'] || 'Sort by:'}}</label>
                            <mat-select class="sort-flight-filter" formControlName="sortOption"
                                (selectionChange)="applyFilters('sort')">
                                <mat-option value="Newest">{{content?.['b2b.managepolicy.sortlist']?.[0]?.Phrase ||
                                    'Newest'}}</mat-option>
                                <mat-option value="Oldest">{{content?.['b2b.managepolicy.sortlist']?.[1]?.Phrase ||
                                    'Oldest'}}</mat-option>
                                <mat-option value="A-Z">{{content?.['b2b.managepolicy.azdropdown']?.[0]?.Phrase ||
                                    'A-Z'}}</mat-option>
                                <mat-option value="Z-A">{{content?.['b2b.managepolicy.azdropdown']?.[1]?.Phrase ||
                                    'Z-A'}}</mat-option>
                            </mat-select>
                            <mat-icon fontSet="material-symbols-outlined" matSuffix> swap_vert </mat-icon>
                        </mat-form-field>
                    </div>
                </div>
                <div class="section-table data-listing text-left">
                    <table class="mat-mdc-table w-100 border-collapse border-0">
                        <thead role="rowgroup" class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row"
                            *ngIf="(policyManagementLists.pipe.length) || (policyManagementListsModel.value.searchValue)">
                            <tr>
                                <th
                                    class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-Division mat-column-Division">
                                    {{content?.['b2b.managepolicy.sno']}}</th>
                                <th
                                    class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-Division mat-column-Division">
                                    {{content?.['b2b.managepolicy.travelpolicy']}}</th>
                                <th
                                    class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-Division mat-column-Division">
                                    {{content?.['b2b.managepolicy.travelcategory']}}</th>
                                <th
                                    class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-Division mat-column-Division">
                                    {{content?.['b2b.managepolicy.appliedon']}}</th>
                                <th
                                    class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-Division mat-column-Division">
                                    {{content?.['b2b.managepolicy.product']}}</th>
                                <th
                                    class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-Division mat-column-Division">
                                    {{content?.['b2b.managepolicy.markettype']}}</th>
                                <th
                                    class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell cdk-column-Division mat-column-Division">
                                    {{content?.['b2b.managepolicy.action']}}</th>
                            </tr>
                        </thead>
                        <tbody role="rowgroup" class="mdc-data-table__content">
                            <ng-container *ngIf="!!policyManagementLists.pipe.length else emptyPolicyLists">
                                <tr class="mat-mdc-row mdc-data-table__row cdk-row"
                                    *ngFor="let policy of policyManagementLists.pipe;let policyIndex=index">
                                    <td
                                        class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-Division mat-column-Division">
                                        {{ getSerialNumber(policyIndex) }}</td>
                                    <td class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-Division mat-column-Division profile-link link cursor-pointer"
                                        (click)="edit(policy.travelPolicy_Id,false)">{{policy.travelPolicy_Title ||
                                        'NA'}}</td>
                                    <td
                                        class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-Division mat-column-Division">
                                        {{policy?.travelCategory || 'NA'}}</td>
                                    <td
                                        class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-Division mat-column-Division">
                                        {{ getAppliedOnName(policy) }}</td>
                                    <td
                                        class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-Division mat-column-Division">
                                        {{ getProductName(policy?.product_Code) }}</td>
                                    <td
                                        class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-Division mat-column-Division">
                                        {{policy?.marketType || 'NA'}}</td>
                                    <td class="mat-mdc-cell mdc-data-table__cell cdk-cell cdk-column-Division mat-column-Division onclick-links"
                                        *ngIf="!Loader.isEditableClicked">
                                        <!-- <a class="onclick-cell primary-link" (click)="edit(policy.travelPolicy_Id,true)">Edit</a>
                                        <a class="onclick-cell warm-link" (click)="deletePolicyModel(selectionWarning,policy)">Remove</a> -->
                                        <a tabindex="0" role="button" aria-label="Edit icon"
                                            class="onclick-cell primary-link"
                                            (keydown.enter)="edit(policy.travelPolicy_Id,true)"
                                            (click)="edit(policy.travelPolicy_Id,true)"><mat-icon
                                                fontSet="material-symbols-outlined">edit</mat-icon></a>
                                        <a tabindex="0" role="button" aria-label="Remove icon"
                                            class="onclick-cell warm-link"
                                            (keydown.enter)="deletePolicyModel(selectionWarning,policy)"
                                            (click)="deletePolicyModel(selectionWarning,policy)"><mat-icon
                                                fontSet="material-symbols-outlined">delete</mat-icon></a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #emptyPolicyLists>
                                <tr colspan="12">
                                    <td colspan="12" class="text-center"><app-cam-empty-state
                                            (myEvent)="handleEvent($event)" [width]="'384px'"
                                            [heading]="content?.['b2b.managepolicy.noresult']" [IsShow]="true"
                                            [content]="content?.['b2b.managepolicy.searchagain'].replace('Try searching again.','')">
                                        </app-cam-empty-state></td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
                
                <div class="f-row more-action justify-center" [style.marginTop.px]="10" *ngIf="totalPages > 1">
                    <button class="button--prev" (click)="prevPage()" [class.disabled]="policyManagementListsModel.value.currentPage <= 1"> 
                        <mat-icon class="material-symbols-outlined me-0">keyboard_arrow_left</mat-icon>  
                    </button>
                    <button mat-button class="button--secondary-small">{{ policyManagementListsModel.value.currentPage }}</button>
                    <button class="button--next" (click)="nextPage()" [class.disabled]="policyManagementListsModel.value.currentPage >= totalPages">
                        <mat-icon class="material-symbols-outlined me-0">keyboard_arrow_right</mat-icon>  
                    </button>
                </div>

                <div class="action-listing"
                    *ngIf="!policyManagementListsModel.value.searchPolicyValue && !!policyManagementLists.pipe.length">
                    <button mat-button class="button--primary-small"
                        (click)="commonObj.STATE = 'ROUTE'; addNewPolicy()">
                        {{content?.['b2b.managepolicy.addnewpolicy'] || 'Add new policy'}} </button>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ROUTE'">
                <div class="menu-left-content">
                    <div class="custom-tree-camp">
                        <ng-container *ngFor="let node of dataSource;">
                            <ng-container *ngIf="node.expandable">
                                <ng-container *ngFor="let child of node?.children">
                                    <!-- [queryParams]="!!commonObj.policyID ? {'enc':commonObj.policyID}:null" -->
                                    <!-- [class.disabled]="!!(this.commonObj.policyID || this._ActivatedRoute.snapshot.queryParams['enc'])" -->
                                    <button type="button" class="button-as-div custom-tree-child"
                                        (click)="menuName(child); redirect(child.navigate)"
                                        [routerLink]="child.navigate" routerLinkActive="active"
                                        [class.tree-disabled]="!(!!this.commonObj.policyID || !!this._ActivatedRoute.snapshot.queryParams['enc'])">
                                        <div class="custom-tree-heading">{{child.name}}</div>
                                        <mat-icon fontSet="material-symbols-outlined"
                                            class="mat-icon-rtl-mirror policy-icon-hider">chevron_right</mat-icon>
                                    </button>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="right-content">
                    <router-outlet></router-outlet>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'WAITING'">
                <app-waiting></app-waiting>
            </ng-container>
            <ng-container *ngSwitchCase="'EMPTY'">
                <app-cam-empty-state (myEvent)="handleEvent($event)" [width]="'384px'"
                    [heading]="'No travel policies configured'" [content]="content?.['b2b.managepolicy.createpolicy']"
                    [navigateTo]="'/cam/policy-management/policy-configuration'"> </app-cam-empty-state>
            </ng-container>
        </ng-container>
    </div>
</section>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.['b2b.managepolicy.confirmchanges']}}
                    </h2>
                    <!-- <div class="custom-overlay-close" *ngIf="!commonObj.isSubmitting">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="selectionWarningModelRef.close()">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description"> {{content?.['b2b.managepolicy.areyousure'] || 'Are you sure you want to delete ?'}} </div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button [class.disabled]="commonObj.isSubmitting"
                            (click)="closePopup()">{{content?.['b2b.managepolicy.cancel']}}</button>
                        <button class="button--primary-small" mat-button [disabled]="commonObj.isSubmitting"
                            (click)="policyDelete()">
                            {{content?.['b2b.managepolicy.confirm'] || 'Confirm'}}
                            <ng-container *ngIf="commonObj.isSubmitting">
                                <mat-spinner class="button"></mat-spinner>
                            </ng-container>
                        </button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #filterModal>
    <div class="custom-popup-gen-container custom-popup-policy-container" [formGroup]="policyManagementListsModel">
        <div class="custom-popup-gen-header">
            <span>{{content?.['b2b.managepolicy.filters'] || 'Filters'}}</span>
            <!-- <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="filterModalRef.close()">close</mat-icon> -->
        </div>
        <div class="custom-popup-gen-body">
            <p class="custom-popup-gen-heading">{{content?.['b2b.managepolicy.markettype']}}</p>
            <div formGroupName="filterMarketType" class="custom-popup-filter">
                <mat-checkbox class="checkbox-wrapper" formControlName="DOM"
                    (change)="onCheckboxTouched('DOM')">{{content?.['b2b.managepolicy.domestic']}}</mat-checkbox>
                <mat-checkbox class="checkbox-wrapper" formControlName="INT"
                    (change)="onCheckboxTouched('INT')">{{content?.['b2b.managepolicy.international']}}</mat-checkbox>
            </div>
            <p class="custom-popup-gen-heading">{{content?.['b2b.managepolicy.product']}}</p>
            <div formGroupName="filterProductCode" class="custom-popup-filter">
                <mat-checkbox class="checkbox-wrapper" formControlName="AIR "
                    (change)="onCheckboxTouched('AIR ')">{{content?.['b2b.managepolicy.flight']}}</mat-checkbox>
                <!-- <mat-checkbox class="checkbox-wrapper" formControlName="CCR "
                    (change)="onCheckboxTouched('CCR ')">{{content?.['b2b.managepolicy.car'] || 'Car'}}</mat-checkbox>
                <mat-checkbox class="checkbox-wrapper" formControlName="HHL "
                    (change)="onCheckboxTouched('HHL ')">{{content?.['b2b.managepolicy.hotel'] ||
                    'Hotel'}}</mat-checkbox>
                <mat-checkbox class="checkbox-wrapper" formControlName="OTH "
                    (change)="onCheckboxTouched('OTH ')">{{content?.['b2b.managepolicy.otherproducts'] || 'Other Products'}}</mat-checkbox> -->
                <!-- <mat-checkbox formControlName="Extras" (change)="onCheckboxTouched('Extras')">Extras</mat-checkbox> -->
            </div>

            <p class="custom-popup-gen-heading">{{content?.['b2b.manageapproval.travelcategory'] || 'Travel Category'}}</p>
            <div formGroupName="filterSelectedTravelCategory" class="custom-popup-filter">
                <ng-container *ngFor="let travel of travelCategoryObj.travelCategory">
                    <mat-checkbox class="checkbox-wrapper" [formControlName]="travel.ID + '::' + travel.Name"
                        (change)="onCheckboxTouched(travel.ID + '::' + travel.Name)">
                        {{ travel.Name }}
                    </mat-checkbox>
                </ng-container>
            </div>

            <p class="custom-popup-gen-heading">{{content?.['b2b.managepolicy.workflowapplied'] || 'Who should this policy apply to?'}}</p>
            <div formGroupName="filterAppliedOn" class="custom-popup-filter">
                <ng-container *ngFor="let on of commonObj.filterAppliedOn">
                    <mat-checkbox class="checkbox-wrapper" [formControlName]="on.ID"
                        (change)="onCheckboxTouched(on.ID)">
                        {{ on.Name ==='Corporate-Branch'?'Corporate-Office location': on.Name}}
                    </mat-checkbox>
                </ng-container>
            </div>
        </div>
        <div class="custom-popup-gen-footer">
            <button class="button--primary-small" mat-button
                (click)="applyFilters('filter');apply()">{{content?.['b2b.managepolicy.apply']}}</button>
        </div>
    </div>
</ng-template>